import { combineEpics } from 'redux-observable';
import { onLoadAdjustmentRulesDoneEpic } from './_epics/onLoadAdjustmentRulesDoneEpic.epic';
import { onUpdateAdjustmentRulesDoneEpic } from './_epics/onUpdateAdjustmentRulesDoneEpic.epic';
import { onValidateAdjustmentRulesDoneEpic } from './_epics/onValidateAdjustmentRulesDoneEpic.epic';
import { validateAdjustmentRulesEpic } from './_epics/validateAdjustmentRules.epic';

export const controllerAdjustmentRulesEpic = combineEpics(
  onLoadAdjustmentRulesDoneEpic,
  onUpdateAdjustmentRulesDoneEpic,
  onValidateAdjustmentRulesDoneEpic,
  validateAdjustmentRulesEpic,
);
